import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

// const Footer = () => {
//   return (
// <footer className="footer">
//       <div className="footer-content">
//       <div className="footer-section about">
//           <h2>Alramlaa Factory</h2>
//           <p>
//           Lorem ipsum dolor sit amet, consectetur
//           adipiscing elit, sed do eiusmod tempor
//           incididunt ut labore et dolore magna aliqua.
//           </p>
//           <div className="social">
//             <Link to="https://facebook.com" target="_blank"> <i className="fab fa-facebook"></i></Link>
//             <Link to="https://twitter.com" target="_blank"><i className="fab fa-twitter"></i></Link>
//             <Link to="https://instagram.com" target="_blank"><i className="fab fa-instagram"></i></Link>
//             <Link to="https://instagram.com" target="_blank"><i className="fab fa-linkedin"></i></Link>
//           </div>
//         </div>
//         <div className="footer-section quick-links">
//           <h2>Quick Links</h2>
//           <ul>
//             <li><Link to="#home">Home</Link></li>
//             <li><Link to="#about">About</Link></li>
//             <li><Link to="#services">Services</Link></li>
//             <li><Link to="#contact">Contact</Link></li>
//           </ul>
//         </div>
//       </div>
//       <div className="footer-bottom">
//         <span className="logo" ><img src={logo1} alt="Logo"></img></span>
//         <p>&copy; 2024 <b>Alramlaa.</b> All rights reserved.</p>
//       </div>
//     </footer>
//   );
// }

const Footer = () => {
  const [t] = useTranslation("global");
  const apiHost = axios.defaults.baseURL
    ? axios.defaults.baseURL.replace(/\/api\/?$/, "")
    : "";
  const footerLogoSrc = apiHost
    ? `${apiHost}/uploads/content/d616a68ab85776fad5676dfe7274245a-logo-w.webp`
    : "/uploads/content/d616a68ab85776fad5676dfe7274245a-logo-w.webp";

  return (
    <footer className="footer">
      <div className="footer-top">
        <Link to={"/"} className="logo">
          <img src={footerLogoSrc} alt="Logo" />
        </Link>
        <div className="social">
          <h3 className="footer-title">{t("footer.stay")}</h3>
          <span className="links">
            <Link
              to="https://www.facebook.com/people/Alramlaa-Wooden-Products/61583094580752/"
              target="_blank"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook"></i>
            </Link>
            <Link
              to="https://www.instagram.com/alramlaa.official/"
              target="_blank"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </Link>
            <Link
              to="https://www.linkedin.com/in/alramlaa-wooden-products-513276293/?skipRedirect=true"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin"></i>
            </Link>
            <Link
              to="https://youtube.com/@alramlaaofficial?si=OBftK2KBFHg9zAJp"
              target="_blank"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </Link>
            <a href="mailto:info@alramlaa.com" aria-label="Email">
              <i className="fa-solid fa-envelope"></i>
            </a>
            <a href="tel:+966544688761" className="phone" aria-label="Phone +966 54 468 8761">
              <i className="fa-solid fa-phone"></i>
            </a>
          </span>
        </div>
        <div className="footer-section quick-links">
          <h3 className="footer-title">{t("footer.links")}</h3>
          <ul>
            <li>
              <Link to="/">{t("footer.home")}</Link>
            </li>
            <li>
              <Link to="/about">{t("footer.about")}</Link>
            </li>
            <li>
              <Link to="/projects">{t("footer.projects")}</Link>
            </li>
            <li>
              <Link to="/store">{t("footer.store")}</Link>
            </li>
            <li>
              <Link to="/contact">{t("footer.contact")}</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section quick-links footer-policies">
          <h3 className="footer-title">
            {t("footer.policiesTitle", { defaultValue: "Store policies" })}
          </h3>
          <ul>
            <li>
              <Link to="/store/policies/shipping">
                {t("footer.policyShipping", { defaultValue: "Shipping" })}
              </Link>
            </li>
            <li>
              <Link to="/store/policies/returns">
                {t("footer.policyReturns", { defaultValue: "Returns" })}
              </Link>
            </li>
            <li>
              <Link to="/store/policies/privacy">
                {t("footer.policyPrivacy", { defaultValue: "Privacy policy" })}
              </Link>
            </li>
            <li>
              <Link to="/store/policies/terms">
                {t("footer.policyTerms", { defaultValue: "Terms" })}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <a
          className="footer-address footer-address-link"
          href="https://maps.app.goo.gl/CmPfDfTtUq5M3iC98?g_st=iwb"
          target="_blank"
          rel="noreferrer"
        >
          طريق الخمرة - المنطقة الصناعية - جدة -المملكة العربية السعودية
        </a>
      </div>
    </footer>
  );
};

export default Footer;
